import { render, staticRenderFns } from "./CourseListManage.vue?vue&type=template&id=1665a702&scoped=true"
import script from "./CourseListManage.vue?vue&type=script&lang=js"
export * from "./CourseListManage.vue?vue&type=script&lang=js"
import style0 from "./CourseListManage.vue?vue&type=style&index=0&id=1665a702&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1665a702",
  null
  
)

export default component.exports